import { IColor, updateSV } from '@fluentui/react';

export const makeHueChangeVisible = (previousColor: IColor, nextColor: IColor): IColor => {
  if (previousColor.s === 0 && nextColor.s === 0 && previousColor.h !== nextColor.h) {
    return updateSV(nextColor, 100, nextColor.v || 100);
  }

  return nextColor;
};